module.exports = __webpack_public_path__ + "static/img/CC6.90cabf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC6.png
// module id = VgwF
// module chunks = 0